exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  max-width: 300px;\n  margin: auto;\n  text-align: center;\n  font-family: arial;\n}\n.card:hover {\n  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  max-width: 300px;\n  margin: auto;\n  text-align: center;\n  font-family: arial;\n  -webkit-transform: scale(1.1);\n          transform: scale(1.1);\n}\n.price {\n  color: grey;\n  font-size: 20px;\n}\n.card button {\n  border: none;\n  outline: 0;\n  padding: 5px;\n  color: white;\n  background-color: #000;\n  text-align: center;\n  cursor: pointer;\n  width: 100%;\n  font-size: 18px;\n}\n.card button:hover {\n  opacity: 0.7;\n}\nimg {\n  height: 300px;\n}\nh1 {\n  font-family: monospace;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/boys/boys.component.css
// module id = ../../../../../src/app/boys/boys.component.css
// module chunks = main